import { render, staticRenderFns } from "./UserManagementPage.vue?vue&type=template&id=12431a8e&scoped=true"
import script from "./UserManagementPage.vue?vue&type=script&lang=ts"
export * from "./UserManagementPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12431a8e",
  null
  
)

export default component.exports